import { render, staticRenderFns } from "./backMoneyApply.vue?vue&type=template&id=b6b08f36&"
import script from "./backMoneyApply.vue?vue&type=script&lang=js&"
export * from "./backMoneyApply.vue?vue&type=script&lang=js&"
import style0 from "./backMoneyApply.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports